import { Loader2 } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface TestSendDialogProps {
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onSend: (email: string) => void;
}

export function TestSendDialog({ isOpen, isLoading, onClose, onSend }: TestSendDialogProps) {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) {
      onSend(email.trim());
    }
  };

  return (
    <div className='fixed inset-0 z-[60] flex items-center justify-center'>
      <div className='fixed inset-0 bg-black/50' onClick={onClose} aria-hidden='true' />
      <div className='relative bg-white rounded-lg shadow-xl p-6 w-full max-w-sm'>
        <h3 className='text-lg font-semibold text-gray-900 mb-4'>{t('notificationTemplates.testSend.title')}</h3>
        <form onSubmit={handleSubmit}>
          <label className='block text-sm font-medium text-gray-700 mb-1'>
            {t('notificationTemplates.testSend.emailLabel')}
          </label>
          <input
            type='email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t('notificationTemplates.testSend.emailPlaceholder')}
            required
            className='w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none'
          />
          <div className='flex justify-end gap-2 mt-4'>
            <button
              type='button'
              onClick={onClose}
              className='px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-md'>
              {t('notificationTemplates.testSend.cancel')}
            </button>
            <button
              type='submit'
              disabled={isLoading || !email.trim()}
              className='inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md disabled:opacity-50'>
              {isLoading && <Loader2 className='h-4 w-4 animate-spin' />}
              {t('notificationTemplates.testSend.send')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
